import React from "react";
import ConfirmationModal from "./ConfirmationModal";

/**
 * Confirmation modal for assigning/overriding a linked programme's PMC version.
 * @param {boolean} open Whether the modal is shown.
 * @param {{title: string, description: string, label: string, icon: string, tone: string}} copy Action copy.
 * @param {string|number} versionValue Currently selected version id.
 * @param {Function} onClose Called on Cancel or dismiss.
 * @param {Function} onConfirm Called when the primary action is clicked.
 */
function VersionAssignmentModal({
    open,
    copy,
    versionValue,
    onClose,
    onConfirm,
}) {
    return (
        <ConfirmationModal
            open={open}
            copy={copy}
            onClose={onClose}
            onConfirm={onConfirm}
            width={546}
            primaryDisabled={!versionValue}
        />
    );
}

export default VersionAssignmentModal;
